var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconLogin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "leftmenu/other/icon-login") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "1.33055874e-13%",
    x2: "50%",
    y2: "104.53891%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb61a",
    stopOpacity: 0.7,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb61a",
    stopOpacity: 0.995478029,
    offset: "100%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "100%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb61a",
    stopOpacity: 0.995478029,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20.6819503,2 C22.0931114,2 23.2370834,3.1545215 23.2370834,4.57869594 L23.2370834,7.94833644 L21.3207336,7.94833644 L21.3207336,4.57869594 C21.3207336,4.22265233 21.0347406,3.93402196 20.6819503,3.93402196 L8.67926638,3.93402196 L13.9129949,5.39672764 C15.1261463,5.95472277 15.9313353,6.3231079 15.9313353,7.72080444 L15.9313353,22.7704207 L20.6819503,22.7704207 C21.0347406,22.7704207 21.3207336,22.4817903 21.3207336,22.1257467 L21.3207336,18.7561062 L23.2370834,18.7561062 L23.2370834,22.1257467 C23.2341232,23.547805 22.0910177,24.6990283 20.6819503,24.6990252 L15.9313353,24.6990252 L15.9313353,25.2624378 C15.9693422,26.047048 15.6971043,26.8147846 15.1744576,27.3969046 C14.7530257,27.8048549 14.1851339,28.0219788 13.6016551,27.9982391 L13.3708343,27.9982391 L5.16864236,24.6881903 L5.08812346,24.6285986 L4.94855737,24.5310849 C4.01990606,24.1464475 3,23.6155395 3,22.1257467 L3,4.57869594 C3,3.1545215 4.14397205,2 5.55513308,2 Z M12.4475509,14.0862829 C11.7389846,14.0862829 11.2021919,15.0180806 11.2021919,16.161158 C11.2021919,17.3042354 11.7604563,18.2306156 12.4475509,18.2306156 C12.7529444,18.2129618 13.0327592,18.0527376 13.2044285,17.7972214 C13.3347695,17.6677272 13.4275765,17.504754 13.4728249,17.3259051 C13.6169318,16.9549093 13.6897992,16.5596354 13.6875419,16.161158 C13.6875419,15.0180806 13.1561172,14.0862829 12.4475509,14.0862829 Z M22.174234,9.74150525 C22.3581053,9.56888905 22.6251066,9.52106865 22.856616,9.61919925 C23.0881253,9.71732985 23.2411947,9.94324224 23.2478193,10.1965692 L23.2478193,11.1933761 L26.3612167,11.1933761 C26.714007,11.1933761 27,11.4820065 27,11.8380501 L27,14.8663926 C27,15.2224362 26.714007,15.5110665 26.3612167,15.5110665 L23.2478193,15.5110665 L23.2478193,16.5295431 C23.2423636,16.7781955 23.0933169,17.0006493 22.8666965,17.0983731 C22.7914568,17.1351702 22.7087403,17.1537211 22.6251398,17.1525998 C22.4561171,17.1509644 22.2943637,17.0829456 22.174234,16.9629374 L19.0501006,13.809994 C18.9291378,13.6889416 18.8610955,13.5241423 18.8610955,13.3522213 C18.8610955,13.1803004 18.9291378,13.0155011 19.0501006,12.8944486 Z",
    id: "path-2"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-16.7%",
    y: "-7.7%",
    width: "133.3%",
    height: "130.8%",
    filterUnits: "objectBoundingBox",
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.05 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "leftmenu/other/icon-login",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-3)",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-1)",
    fillRule: "evenodd",
    xlinkHref: "#path-2"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogin);
export default __webpack_public_path__ + "static/media/icon-login.17a8e5e3e2f7d7ea884c3a1188e6cb78.svg";
export { ForwardRef as ReactComponent };